import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  root: {
    backgroundColor: theme.palette.white,
    padding: pxToRem(16),
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  choiceGroup: {
    selectors: {
      '.ms-ChoiceFieldGroup-flexContainer': {
        display: 'flex',
      },
      '.ms-ChoiceField': {
        marginRight: pxToRem(20),
      },
      '.ms-ChoiceFieldLabel': {
        fontWeight: 'normal',
      },
    },
  },
  dropdownOption: {
    marginBottom: pxToRem(10),
  },
  loadingSpinner: {
    marginRight: pxToRem(10),
  },
  save: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: pxToRem(4),
    minHeight: pxToRem(24),
  },
  saveFilterButton: {
    flexShrink: '0',
    alignSelf: 'flex-start',
    marginTop: pxToRem(3),
  },
  filterSentenceContainer: {
    flex: '1 1 auto',
    paddingRight: pxToRem(10),
  },
  filterSentence: {
    fontWeight: 400,
  },
  formValuesDescription: {
    fontWeight: 'normal',
    paddingTop: pxToRem(7),
    paddingBottom: pxToRem(7),
  },
});
